import "./style.scss";
import $ from 'jquery';
import 'slick-carousel';
import "slick-carousel/slick/slick.scss";

$(document).ready(function () {
    $('.hero-slider__slider').slick({
        infinite: false,
        slidesToShow: 1,
        arrows: true,
        fade: true,
        appendArrows: $(".hero-slider__arrows"),
        nextArrow: '<div class="ow_slick_arrow ah_front_next"><svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M2.10695 0.47998L0.498177 2.08876L9.9094 11.5L0.498177 20.9112L2.10695 22.52L13.127 11.5L2.10695 0.47998Z" fill="#383838"/> </svg></div>',
        prevArrow: '<div class="ow_slick_arrow ah_front_prev"><svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2049 0.482422L12.8133 2.09085L3.40417 11.5L12.8133 20.9092L11.2049 22.5176L0.187317 11.5L11.2049 0.482422Z" fill="#383838"/> </svg></div>',
    });

    $('.hero-slider__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.hero-slider__nav-single').removeClass('hero-slider__nav-single--current');
        $('.hero-slider__nav-single[data-slide="' + nextSlide + '"]').addClass('hero-slider__nav-single--current');
    });

    $('.hero-slider__nav-single[data-slide]').on("click", function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.hero-slider__slider').slick('slickGoTo', slideno);
        $('.hero-slider__nav-single').removeClass('hero-slider__nav-single--current');
        $('.hero-slider__nav-single[data-slide="' + slideno + '"]').addClass('hero-slider__nav-single--current');
    });
});